import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"
import FormComponent from "../../form"

const PromoForm = ({ title, richContent, steps, caption, form }) => {

  let promoTitle = 'Crown Melbourne Competition'
  
  return (
    <section className="promo-form" id="enter">
      <div className="promo-form__inner">
        <div className="promo-form__items">
          <div className="promo-form__content">
            {title && <h2>{parse(title)}</h2>}
            {richContent && <StructuredText data={richContent} />}

            <div className="promo-form__steps">
              {steps?.length > 0 &&
                steps?.map((item, index) => (
                  <div key={index} className="promo-form__step">
                    {item?.title && <h3>{parse(item?.title)}</h3>}
                    {item?.richContent && (
                      <StructuredText data={item?.richContent} />
                    )}
                  </div>
                ))}
            </div>

            {caption && <h4>{parse(caption)}</h4>}
          </div>

          <div className='promo-form__form' data-lenis-prevent>
            {form?.length > 0 && <FormComponent promoTitle={promoTitle} form={form[0].form}/>}
          </div> 
        </div>
      </div>
    </section>
  )
}

export default PromoForm

export const query = graphql`
  fragment PromoFormProps on DatoCmsPromoForm {
    ... on DatoCmsPromoForm {
      id
      title
      richContent {
        value
      }
      steps {
        title
        richContent {
          value
        }
      }
      form {
        form {
          ...FormProps
        }
      }
      caption
    }
  }
`
